import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/data");

export const Route = createFileRoute("/data/")({
  head: () => ({
    meta: [
      { title: "Data overview — LevelLoad" },
      { name: "description", content: "Data sources and refresh cadences used by LevelLoad." },
      { property: "og:title", content: "Data overview — LevelLoad" },
      {
        property: "og:description",
        content: "Data sources and refresh cadences used by LevelLoad.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
